<template>
	<div class="input__wrapper input__wrapper--select">
		<label>
			<span class="input-label" :id="data.labelId">{{ data.label }}<span class="input__wrapper-mandatory" v-if="data.mandatoryFiled">*</span></span>
			<treeselect
				:options="capitalizeLabels(data.options)"
				:placeholder="data.placeholder"
				v-model="inputVal"
				:searchable="data.searchable"
				:id="data.inputId"
				:multiple="data.multiple"
				:no-results-text="data.noResultsText"
				:limit="1"
				:open="true"
				:disabled="data.disabled"
			/>
		</label>
	</div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	components: {
		Treeselect
	},
	data () {
		return {
			inputVal: this.value
		};
	},
	watch: {
		inputVal (val) {
			if (val) {
				this.$emit('input', val);
			} else {
				// When input is cleared emit empty value for update
				if (this.data.multiple) {
					this.$emit('input', []);
				} else {
					this.$emit('input', '');
				}
			}
		}
	},
	methods: {
		capitalizeLabels(data) {
			return data.map((el) => {
				el.label = el.label.charAt(0).toUpperCase() + el.label.slice(1);
				return el;
			});
		},
		setValue(value) {
			if (value) {
				// NOTE: Refactor because of new agent
				if (Array.isArray(value)) {
					if (value.length > 0) {
						this.inputVal = value;
					}
				} else {
					this.inputVal = value;

					if (this.data.multiple) {
						this.inputVal = JSON.parse(value);
					}
				}
			} else {
				this.inputVal = this.value;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.input__wrapper {
	select {
		display: block;
		box-shadow: none;
		border: 1px solid $white-lilac;
		padding: 14px 16px;
		line-height: 1.2;
		width: 100%;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;
		background-color: $white-lilac;

		@include mq($sm) {
			font-size: 16px;
			padding: 13px;
		}

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}
}
</style>
